import { render, staticRenderFns } from "./GBProjectListRow.vue?vue&type=template&id=2b741026&"
import script from "./GBProjectListRow.vue?vue&type=script&lang=js&"
export * from "./GBProjectListRow.vue?vue&type=script&lang=js&"
import style0 from "./GBProjectListRow.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/ganttboard/project/ganttboard-frontend/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
installComponents(component, {VAvatar,VIcon})
